import get from 'lodash/get';

import type { AppData } from '../../types/app_data';
import type { Step } from '../types/step';
import { StepCategory } from '../../types/app_data';
import { HomeOwnership } from '../../types/homeownership.enum';
import { growthBookInstance } from '../../utils/analytics/growthbook';
import { ABTestSignupHomeQuotingCA } from '../../utils/enabled_features/ab_tests';
import type { ABTest } from '../../utils/enabled_features/types';

const STATE_TEST_MAP: Record<string, ABTest> = {
  CA: ABTestSignupHomeQuotingCA,
};

const getHomeQuotingTestEnabled = (state: string) => {
  const abTest = get(STATE_TEST_MAP, state);
  return abTest ? (growthBookInstance?.isOn(abTest.storageKey) ?? false) : true;
};

export const BundleOptInStep: Step = {
  // Ask bundle opt in
  id: 'askBundleOptIn',
  pathname: '/bundleoptin',
  canShow: (appData: AppData) => {
    if (!appData.selectedService?.insurance) {
      return false;
    }
    if (appData.signupParams?.needNNOInsurance === true) {
      return false;
    }
    if (appData.isOnboardingLite) {
      return false;
    }

    if (appData.signupParams?.homeOwnership === HomeOwnership.DoesNotHoldTitle) {
      return false;
    }
    if (appData.signupParams?.homeOwnership !== HomeOwnership.Owned) {
      return true;
    }

    return getHomeQuotingTestEnabled(appData.address?.state ?? '');
  },
  hasData: () => true,
  hasOwnData: () => true,
  category: () => StepCategory.Other,
};
